var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FBEBEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22C23 22 24 22 24 21C24 20 23 17 19 17C15 17 14 20 14 21C14 22 15 22 15 22H23ZM15.0223 21C15.0189 20.9996 15.014 20.999 15.0081 20.998C15.0054 20.9975 15.0027 20.997 15 20.9965C15.0015 20.7325 15.1669 19.9669 15.7593 19.2758C16.3133 18.6294 17.2827 18 19 18C20.7173 18 21.6867 18.6294 22.2407 19.2758C22.8331 19.9669 22.9985 20.7325 23 20.9965C22.9973 20.997 22.9946 20.9975 22.9919 20.998C22.986 20.999 22.9811 20.9996 22.9777 21H15.0223Z",
    fill: "#DC3545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15C20.1046 15 21 14.1046 21 13C21 11.8954 20.1046 11 19 11C17.8954 11 17 11.8954 17 13C17 14.1046 17.8954 15 19 15ZM22 13C22 14.6569 20.6569 16 19 16C17.3431 16 16 14.6569 16 13C16 11.3431 17.3431 10 19 10C20.6569 10 22 11.3431 22 13Z",
    fill: "#DC3545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9359 17.28C14.5681 17.1623 14.1595 17.0768 13.7063 17.0331C13.4819 17.0114 13.2467 17 13 17C9 17 8 20 8 21C8 21.6667 8.33333 22 9 22H13.2164C13.0756 21.7159 13 21.3791 13 21C13 19.9897 13.3772 18.958 14.0898 18.0962C14.3333 17.8017 14.6159 17.5271 14.9359 17.28ZM12.92 18.0005C12.3226 18.9136 12 19.9547 12 21H9C9 20.7393 9.16424 19.97 9.75926 19.2758C10.3047 18.6395 11.2525 18.0197 12.92 18.0005Z",
    fill: "#DC3545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 13.5C9.5 11.8431 10.8431 10.5 12.5 10.5C14.1569 10.5 15.5 11.8431 15.5 13.5C15.5 15.1569 14.1569 16.5 12.5 16.5C10.8431 16.5 9.5 15.1569 9.5 13.5ZM12.5 11.5C11.3954 11.5 10.5 12.3954 10.5 13.5C10.5 14.6046 11.3954 15.5 12.5 15.5C13.6046 15.5 14.5 14.6046 14.5 13.5C14.5 12.3954 13.6046 11.5 12.5 11.5Z",
    fill: "#DC3545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.03ba24728b467756497029673ef6d725.svg";
export { ForwardRef as ReactComponent };